import { DatePipe } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectChange } from "@angular/material/select";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { PartnerService } from "../services/partner.service";

declare var $: any;
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

@Component({
  selector: 'app-direct-nach-clearing',
  templateUrl: './direct-nach-clearing.component.html',
  styleUrls: ['./direct-nach-clearing.component.scss']
})
export class DirectNachClearingComponent implements OnInit, AfterViewInit {

  currentUser: any;
  FromDate: any;
  ToDate: any;
  showSpinner: boolean = false;

  // New variables for Clearing/Bounce
  Type: string = '';
  BounceDate: any;
  BounceReason: any;
  BounceCharge: any = 0;
  ClearDate: any;
  Bounce_ReasonList: any[] = [];
  minDate: any;
  Row: any = {};
  selectedId: any;

  dataSource = new MatTableDataSource<any>([]);

  displayedColumns = [
    'sno',
    'Customer_LoanAcNo',
    'Partner_LoanAcNo',
    'CustomerName',
    'Period',
    'DueDate',
    'EMI_Amount',
    'Clearing_Bounce'
  ];

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  @ViewChild('paginatorRef') paginator1!: MatPaginator;
@ViewChild('paginatorRef1') paginator2!: MatPaginator;

  arrayBuffer: any;
  file: any;
  filelist: any;
  EmiAmount: any;
  voucherModel: any;
  Matchhdata: any;
  MisMatchdata: any;
    ImportBulkProcess: any[] = [];
    displayedColumnsBulkImport: string[] = [];
    displayedColumnsNotMatchImport: string[] = [];
    dataSourceBulkImport: any;
    dataSourceBulkImport_NotMatch: any;


  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private _Partnerservice: PartnerService,
    private snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private lmsService: LmsService,
    private dataSharingService: DataSharingService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser") || '{}');
    this.dataSharingService.HeaderTitle.next("Direct NACH Clearing");

    this.minDate = new Date(this.currentUser.Data_Freeze?.split("T")[0] || new Date());
    this.lmsService
      .LMS_Commaon_Master({ Commands: "Select", Type: "Bounce_Reason" })
      .subscribe((res: any) => {
        this.Bounce_ReasonList = res;
      });
  }

  // ngAfterViewInit(): void {
  //   // Don't assign here since table is hidden initially with *ngIf
  //   // We'll assign after data loads
  // }
  ngAfterViewInit() {
  this.dataSourceBulkImport.paginator = this.paginator1;
  this.dataSourceBulkImport_NotMatch.paginator = this.paginator2;
}

  getMAS_EMIPaybleDetails() {
    if (!this.FromDate || !this.ToDate) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please select both dates",
        ...this.configSuccess,
      });
      return;
    }

    this.showSpinner = true;
    this.dataSource.data = [];

    this._Partnerservice.MAS_EMIPaybleDetails({
      FromDate: this.FromDate,
      ToDate: this.ToDate
    }).subscribe({
      next: (res: any[]) => {
        this.showSpinner = false;
        if (res && res.length > 0) {
          // Initialize ClearingType for each row
          const processedData = res.map(row => ({
            ...row,
            ClearingType: row.ClearingType || '',
            Clearinghold: row.Clearinghold || false
          }));

          this.dataSource.data = processedData;

          // ✅ FIX: Assign paginator and sort AFTER data loads and view updates
          setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            // Force change detection
            this.cdr.detectChanges();
          });

        } else {
          this.dataSource.data = [];
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
        }
      },
      error: (err) => {
        this.showSpinner = false;
        this.dataSource.data = [];
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Failed to load data",
          ...this.configSuccess,
        });
      }
    });
  }

  totaltypewise(type: string): number {
    if (!this.dataSource?.filteredData?.length) return 0;
    return this.dataSource.filteredData
      .reduce((sum, row) => sum + Number(row[type] || 0), 0);
  }

  exportTable(exporter: any) {
    exporter.exportTable('xlsx', {
      fileName: 'MAS_EMIPaybleDetails',
      sheet: 'EMI_Details',
      Props: { Author: this.currentUser.userName }
    });
  }

  highlightRow(row: any) {
    this.selectedId = row.Loan_Id;
  }

  ClearingChange(event: MatSelectChange, row: any) {
    this.Row = row;
    this.Type = event.value;

    if (event.value === "Bounce") {
      this.BounceDate = new Date(this.Row.DueDate);
      this.BounceReason = null;
      this.BounceCharge = row.BounceCharge || 0;
    }
    else if (event.value === "Clear") {
      this.ClearDate = new Date(this.Row.DueDate);
    }

    $("#BounceDetailModel").modal("show");
    $("#BounceDetailModel").css("z-index", "1050");
  }

  onCloseBounceDetail() {
    this.Type = '';
    this.Row = {};
    $("#BounceDetailModel").modal("hide");
  }

  onBounce() {
    this._Partnerservice
      .MAS_Save_EMIPaybleSingle({
        Loan_Id: this.Row.Loan_Id,
        Id: this.Row.Id,
        Status: this.Type,
        Date: this.datePipe.transform(
          new Date(this.BounceDate).toString(),
          "yyyy-MM-dd"
        ),
        BounceReasonCode: this.BounceReason,
      })
      .subscribe((rres: any) => {
        if (rres[0].CODE == 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: rres[0].MSG,
            ...this.configSuccess,
          });
          this.onCloseBounceDetail();
          this.getMAS_EMIPaybleDetails();
        }
        else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: rres[0].Message,
            ...this.configSuccess,
          });
        }
      });
  }

  onClear() {
    this._Partnerservice
      .MAS_Save_EMIPaybleSingle({
        Loan_Id: this.Row.Loan_Id,
        Id: this.Row.Id,
        Status: this.Type,
        Date: this.datePipe.transform(
          new Date(this.ClearDate).toString(),
          "yyyy-MM-dd"
        ),
        LoginUserId: this.currentUser.userId
      })
      .subscribe((result: any) => {
        if (result[0].CODE == 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: result[0].MSG,
            ...this.configSuccess,
          });
          this.onCloseBounceDetail();
          this.getMAS_EMIPaybleDetails();
        }
        else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: result[0].Message,
            ...this.configSuccess,
          });
        }
      });
  }
  bulkImportTemplate(excelFileName: string): void {
      // var json=[{Date:'',Rec_No:'',Rec_date:'',Loan_No:'',EMI_Amt:'',OD_Amt:'',Other_Amt:''}]
      var json = [
        [
          "PartnerLoanNo",
          "EMI_Amount",
          "voucherDate",
          "DueDate",
          "ReasonCode",
        ],
      ];
      const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(json);
      // console.log('worksheet',worksheet);
      const workbook: XLSX.WorkBook = {
        Sheets: { data: worksheet },
        SheetNames: ["data"],
      };
      const excelBuffer: any = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
      this.saveAsExcelFile(excelBuffer, excelFileName);
    }
    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE,
        });
        FileSaver.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }

  //  bulkImportTemplate() {
  //   const templateData = this.dataSource.data.map(row => {
  //     return {
  //       PartnerLoanNo: "",
  //       EMI_Amount: "",
  //       voucherDate: "",
  //       DueDate: "",
  //       ReasonCode: ""
  //     };
  //   });

  //   // Using xlsx library (Recommended)
  //   const wb = XLSX.utils.book_new();
  //   const ws = XLSX.utils.json_to_sheet(templateData);

  //   // Add header instructions
  //   XLSX.utils.sheet_add_aoa(ws, [
  //     ["PartnerLoanNo", "EMI_Amount", "voucherDate", "DueDate", "ReasonCode"],
  //     ["", "", "", "", ""]
  //   ], { origin: "A1" });

  //   XLSX.utils.book_append_sheet(wb, ws, "Import_Template");

  //   // Download file
  //   XLSX.writeFile(wb, `Direct_Nach_Import_Template_${new Date().toISOString().slice(0, 10)}.xlsx`);

  //   this.snackBar.openFromComponent(SnackbarComponent, {
  //     data: "Import Template Downloaded Successfully (5 Columns)",
  //     ...this.configSuccess,
  //   });
  // }


      bulkImport(event) {
          this.showSpinner = true;
          this.Matchhdata = null;
          this.MisMatchdata = null;
          this.ImportBulkProcess = null;
          this.file = event.target.files[0];
          let fileReader = new FileReader();
          fileReader.readAsArrayBuffer(this.file);
          fileReader.onload = (e) => {
            this.arrayBuffer = fileReader.result;
            var data = new Uint8Array(this.arrayBuffer);
            var arr = new Array();
            for (var i = 0; i != data.length; ++i)
              arr[i] = String.fromCharCode(data[i]);
            var bstr = arr.join("");
            var workbook = XLSX.read(bstr, { type: "binary" });
            var first_sheet_name = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[first_sheet_name];
            //console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
            // this.ImportBulkProcess = XLSX.utils.sheet_to_json(worksheet, {
            //   raw: false,
            //   dateNF: "yyyy-mm-dd",
            // });
            this.ImportBulkProcess = XLSX.utils.sheet_to_json(worksheet, {
              raw: false,
              dateNF: "yyyy-mm-dd",
            }).map((row: any) => {
              const newRow: any = {};
              Object.keys(row).forEach((key) => {
                newRow[key.trim()] = row[key]; // remove spaces
              });
              return newRow;
            });
            console.log(Object.keys(this.ImportBulkProcess[0]));
      
            console.log("ImportBulkProcess", this.ImportBulkProcess);
            // let errors: any[] = [];

            // this.ImportBulkProcess.forEach((row: any, index: number) => {
            //   // EMI validation
            //   if (!row.EMI_Amount || Number(row.EMI_Amount) === 0) {
            //     errors.push({
            //       row: index + 1,
            //       error: "EMI_Amount should not be 0 or null",
            //     });
            //   }

            //   // Date validation (yyyy-mm-dd)
            //   const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

            //   if (row.voucherDate && !dateRegex.test(row.voucherDate)) {
            //     errors.push({
            //       row: index + 1,
            //       error: "voucherDate must be yyyy-mm-dd",
            //     });
            //   }

            //   if (row.DueDate && !dateRegex.test(row.DueDate)) {
            //     errors.push({
            //       row: index + 1,
            //       error: "DueDate must be yyyy-mm-dd",
            //     });
            //   }
            // });
            // if (errors.length > 0) {
            //   this.showSpinner = false;

            //   console.log("Validation Errors", errors);

            //   this.snackBar.open(
            //     "Validation failed. Please check imported file.",
            //     "Close",
            //     { duration: 3000 }
            //   );

            //   return;
            // }
            this._Partnerservice
              .MAS_MatchImport_EMIPaybleDetails({
                LoginUserId: this.currentUser.userId,
                JSON: JSON.stringify(this.ImportBulkProcess),
              })
              .subscribe((res) => {
                if (res[0].CODE == 0) {
                  this.showSpinner = false;
                  this.snackBar.openFromComponent(SnackbarComponent, {
                    data: res[0].Msg,
                    ...this.configSuccess,
                  });
                } else {
                  this.showSpinner = false;
                  this.displayedColumnsBulkImport = [
                    "Id",
                    "PartnerLoanNo",
                    "EMI_Amount",
                    "voucherDate",
                    "DueDate",
                    "ReasonCode",
                  ];
                  this.displayedColumnsNotMatchImport = [
                    "Id",
                    "PartnerLoanNo",
                    "EMI_Amount",
                    "voucherDate",
                    "DueDate",
                    "ReasonCode",
                    "NotMach"
                  ];
                  var ImportData = JSON.parse(JSON.stringify(res));
                  this.Matchhdata = ImportData.filter((x) => x.NotMach == null || x.NotMach == "");
                  this.MisMatchdata = ImportData.filter((x) => x.NotMach != null && x.NotMach != "");
                  this.dataSourceBulkImport = new MatTableDataSource(
                    ImportData.filter((x) => x.NotMach == null || x.NotMach == "") 
                  );
                  this.dataSourceBulkImport.sort = this.sort;
                  // this.dataSourceBulkImport.paginator = this.paginator;
      
                  this.dataSourceBulkImport_NotMatch = new MatTableDataSource(
                    ImportData.filter((x) => x.NotMach != null && x.NotMach != "")
                  );
                  this.dataSourceBulkImport_NotMatch.sort = this.sort;
//                   setTimeout(() => {
//   this.dataSourceBulkImport.paginator = this.paginator1;
//   this.dataSourceBulkImport_NotMatch.paginator = this.paginator2;
// });
                  console.log("MisMatchdata", this.MisMatchdata);
                  console.log("Matchhdata", this.Matchhdata);
                  console.log("dataSourceBulkImport", this.dataSourceBulkImport);
                  console.log("dataSourceBulkImport_NotMatch", this.dataSourceBulkImport_NotMatch);
                  // this.dataSourceBulkImport_NotMatch.paginator = this.paginator;
                  $("#bulkImportModel").modal("show");
                  $("#bulkImportModel").css("z-index", "1050");
                }
              });
              event.target.value = null;
          };
        }
         onExportMisMatch(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `Direct_Nach_MisMatch_List`,
      sheet: "Direct_Nach_MisMatch_List",
    });
  }
   onBulkVoucherSave() {
    this.showSpinner = true;

    // Check for missing required fields before saving
    const invalidRows = this.Matchhdata.filter(
      x => !x.voucherDate || x.voucherDate === ''
    );

    if (invalidRows.length > 0) {
      this.showSpinner = false;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Error: ${invalidRows.length} row(s) have empty Date. Please fix before saving.`,
        ...this.configSuccess,
      });
      return; // Stop the save
    }

    console.log("Valid Matchhdata", this.Matchhdata);

    this._Partnerservice
      .MAS_SaveImport_EMIPaybleDetails({
        LoginUserId: this.currentUser.userId,
        JSON: JSON.stringify(this.Matchhdata),
      })
      .subscribe((res: any) => {
        this.showSpinner = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
                    data: res[0].MSG,
                    ...this.configSuccess,
                  });
        // Handle success or response messages here if needed
      });

    this.onCloseBulkImport();
  }
  onCloseBulkImport() {
    this.displayedColumnsBulkImport = [];
    this.displayedColumnsNotMatchImport = [];
    this.dataSourceBulkImport = null;
    this.ImportBulkProcess = null;
    this.Matchhdata = null;
    this.MisMatchdata = null;

    $("#bulkImportModel").modal("hide");
  }

}